export const updateMeta = {
  title: meta => {
    if (meta) {
      document.title = meta.title;
    }
  },
};
